import { render } from "./notes-modal.vue?vue&type=template&id=83a00ef0&scoped=true"
import script from "./notes-modal.vue?vue&type=script&lang=js"
export * from "./notes-modal.vue?vue&type=script&lang=js"

import "./notes-modal.vue?vue&type=style&index=0&id=83a00ef0&scoped=true&lang=css"
import "./notes-modal.vue?vue&type=style&index=1&id=83a00ef0&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a00ef0"]])

export default __exports__